import clsx from 'clsx';
import React, { type FC, type PropsWithChildren } from 'react';

import type { TextSizeType } from '../utils';

type PreTagProps = {
  hasTitle: boolean;
  textSize: TextSizeType;
  className?: string;
  truncateLongLines?: boolean;
};

export const PreTag: FC<PropsWithChildren<PreTagProps>> = ({
  hasTitle,
  children,
  textSize,
  className,
  truncateLongLines = false,
}) => {
  const classes = clsx(
    [
      'codeblock-pre',
      'px-f2',
      'bg-negative',
      'scrollbar-hide',
      'w-full',
      'min-w-f0',
    ],
    truncateLongLines
      ? ['whitespace-pre', 'overflow-hidden']
      : ['whitespace-pre-wrap', 'break-all', 'overflow-auto'],
    hasTitle && 'pb-f2',
    !hasTitle && 'py-f2',
    `text-${textSize}`,
    className
  );
  return <pre className={classes}>{children}</pre>;
};
